import {
  commonSelectors,
  createQcsThunks,
  createResourceEntityAdapter,
} from 'app-components/flux/core/resourceSliceUtils';

import { getLogger } from 'app-components/utils/core';
import { createAppSlice } from 'app-components/utils/redux-store/createAppSlice';

import retirementPlannerApi from 'data/retirementPlanner/retirementPlannerApi';
import type { RetirementPlannerState, RetirementStorageData } from 'data/retirementPlanner/retirementPlannerTypes';
import { RETIREMENT_PLANNER_REDUCER_KEY } from 'data/retirementPlanner/retirementPlannerTypes';

const log = getLogger('data/retirement-planner/retirementPlannerSlice.ts');

// Define the initial empty state.
// when we dispatch retirementPlannerActions.fetch().
const initialState: RetirementPlannerState = {
  entities: {},
  ids: [],
  isLoading: false,
  loadPending: true,
  error: null,
  lastSyncDate: null,
};

// Create an entity adapter for handling a single RetirementStorageData resource.
const entityAdapter = createResourceEntityAdapter<RetirementStorageData>();
const entitySelectors = entityAdapter.getSelectors();

// Create the slice using createAppSlice utility function
export const slice = createAppSlice({
  name: RETIREMENT_PLANNER_REDUCER_KEY, // Name of the slice
  initialState: entityAdapter.getInitialState(initialState), // Initial state with entity adapter
  reducers: (create) =>
    createQcsThunks({
      create,
      refetch(dispatch) {
        // If a refetch is needed, simply call fetch again.
        dispatch(slice.actions.fetch());
      },
      api: retirementPlannerApi, // API for retirement planner
      adapter: entityAdapter, // Entity adapter for handling resources
      log, // Logger instance
    }),
  selectors: {
    ...entitySelectors, // Entity selectors
    ...commonSelectors, // Common selectors
  },
});

// Export actions and selectors for the retirement planner slice
export const retirementPlannerActions = slice.actions;
export const retirementPlannerSelectors = slice.selectors;
export { slice as retirementPlannerSlice };

// Export the reducer as the default export
export default slice.reducer;
